import axios from 'axios';
import { translate } from 'react-jhipster';
import { Storage } from 'react-jhipster';

import { REQUEST, SUCCESS, FAILURE } from 'app/shared/reducers/action-type.util';

export const ACTION_TYPES = {
  RESET_PASSWORD_INIT: 'passwordReset/RESET_PASSWORD_INIT',
  RESET_PASSWORD_FINISH: 'passwordReset/RESET_PASSWORD_FINISH',
  SEND_OTP: 'register/SEND_OTP',
  RE_SEND_OTP: 'register/RE_SEND_OTP',
  RESET: 'passwordReset/RESET',
  GENERATE_CAPTCHA: 'passwordReset/GENERATE_CAPTCHA'
};

const initialState = {
  loading: false,
  resetPasswordSuccess: false,
  resetPasswordFailure: false,
  responseInit: {} as any,
  response: {} as any,
  responseReSend: {} as any,
  responseFinish: {} as any,
  responseCaptcha: {} as any
};

export type PasswordResetState = Readonly<typeof initialState>;

// Reducer
export default (state: PasswordResetState = initialState, action): PasswordResetState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.RESET_PASSWORD_FINISH):
    case REQUEST(ACTION_TYPES.RESET_PASSWORD_INIT):
    case REQUEST(ACTION_TYPES.SEND_OTP):
    case REQUEST(ACTION_TYPES.RE_SEND_OTP):
      return {
        ...state,
        loading: true
      };
    case FAILURE(ACTION_TYPES.RESET_PASSWORD_FINISH):
    case FAILURE(ACTION_TYPES.RESET_PASSWORD_INIT):
      return {
        ...initialState,
        loading: false,
        resetPasswordFailure: true
      };
    case SUCCESS(ACTION_TYPES.RESET_PASSWORD_FINISH):
      return {
        ...initialState,
        responseFinish: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.RESET_PASSWORD_INIT):
      Storage.session.set('phone', action.payload.data.mobile);
      return {
        ...initialState,
        loading: false,
        resetPasswordSuccess: true,
        responseInit: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.SEND_OTP):
      return {
        ...state,
        response: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.RE_SEND_OTP):
      return {
        ...state,
        responseReSend: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.GENERATE_CAPTCHA):
      return {
        ...state,
        responseCaptcha: action.payload.data
      };

    case ACTION_TYPES.RESET:
      return {
        ...initialState
      };
    default:
      return state;
  }
};

const apiUrl = 'api/register/password';

// Actions
export const handlePasswordResetInit = (login, code) => ({
  type: ACTION_TYPES.RESET_PASSWORD_INIT,
  // If the content-type isn't set that way, axios will try to encode the body and thus modify the data sent to the server.
  payload: axios.get(`${apiUrl}/forgot`, {
    params: {
      login: login,
      captcha: code
    },
    headers: { ['Content-Type']: 'text/plain' }
  })
  // meta: {
  //   successMessage: translate('reset.request.messages.success'),
  //   errorMessage: translate('reset.request.messages.notfound')
  // }
});

export const handlePasswordResetFinish = (id, password, key, phone) => ({
  type: ACTION_TYPES.RESET_PASSWORD_FINISH,
  payload: axios.post(`${apiUrl}/reset/finish`, { id, key, phone, password })
  // meta: {
  //   successMessage: translate('reset.finish.messages.success')
  // }
});

export const sendOtp = (id, phone, key) => ({
  type: ACTION_TYPES.SEND_OTP,
  payload: axios.post(`${apiUrl}/verify/otp`, { id, phone, key })
});

export const reSendOtp = (id, phone, captcha) => ({
  type: ACTION_TYPES.RE_SEND_OTP,
  payload: axios.post(`${apiUrl}/resend/otp`, { id, phone, captcha })
});

export const reset = () => ({
  type: ACTION_TYPES.RESET
});

export const generateCaptcha = () => ({
  type: ACTION_TYPES.GENERATE_CAPTCHA,
  payload: axios.get(`${apiUrl}/generate/captcha`)
});
